import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileTextOutlined, CommentOutlined, ContactsOutlined, FileImageOutlined, LockOutlined, PictureOutlined, InfoCircleOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import Router from './Routes';
// import { Routes, Route, Navigate } from 'react-router-dom';

function App() {
	const [collapsed, setCollapsed] = useState(false);
	const navigate = useNavigate();

	return (
		<Layout
			style={{
				minHeight: '100vh',
			}}
		>
			<Layout.Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
				<div
					style={{
						height: 60,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<img src='/images/logo.png' alt='Logo' style={{ height: 18, width: 'auto' }} />
				</div>

				<Menu
					theme='dark'
					defaultSelectedKeys={['1']}
					mode='inline'
					items={[
						{
							label: 'About',
							icon: <InfoCircleOutlined />,
							onClick: () => {
								navigate('/about');
							},
						},
						{
							label: 'Contact Us',
							icon: <ContactsOutlined />,
							onClick: () => {
								navigate('/contact');
							},
						},
						{
							label: 'Main Slider',
							icon: <FileImageOutlined />,
							onClick: () => {
								navigate('/main-slider');
							},
						},
						{
							label: 'Testimonials ',
							icon: <CommentOutlined />,
							onClick: () => {
								navigate('/testimonials ');
							},
						},
						{
							label: 'Gallery',
							icon: <PictureOutlined />,
							onClick: () => {
								navigate('/gallery');
							},
						},
						{
							label: 'Privacy',
							icon: <LockOutlined />,
							onClick: () => {
								navigate('/privacy');
							},
						},
						{
							label: 'Terms & Services',
							icon: <FileTextOutlined />,
							onClick: () => {
								navigate('/terms-services');
							},
						},
						{
							label: 'FAQ',
							icon: <QuestionCircleOutlined />,
							onClick: () => {
								navigate('/faq');
							},
						},
						{
							label: 'Settings',
							icon: <SettingOutlined />,
							onClick: () => {
								navigate('/settings');
							},
						},
					]}
				/>
			</Layout.Sider>
			<Layout className='site-layout'>
				<Router />
				<Layout.Footer
					style={{
						padding: '8px 16px',
						textAlign: 'center',
						fontSize: 11,
					}}
				>
					Developed by Dot and Dash Technologies Pvt. Ltd.
				</Layout.Footer>
			</Layout>
		</Layout>
	);
}

export default App;
